import { Modal } from 'antd';
import { func } from 'prop-types';
import React from 'react';
import service from '../services'
import fetch from '../services/fetch';
import utils from '../utils';

export default class CasLogin extends React.Component {

    constructor(props) {
        super(props)
    }

    async componentDidMount() {
        // service.account.website().then(data => {
        //     sessionStorage.setItem('website', JSON.stringify(data));
        //     document.title = data.systemName;
        //     this.setState(Object.assign({}, this.state, data));
        // });

        let data = await service.account.website();
        
        sessionStorage.setItem('website', JSON.stringify(data));
        document.title = data.systemName;
        this.setState(Object.assign({}, this.state, data));

        const url = window.location.hash;
        let index = url.indexOf('?');
        let emId = 0
        if(index > -1) {
            casLogin = casLogin +  url.substr(index);
            emId = url.substr(url.indexOf('emId=')+7);
        }
        fetch.get(casLogin).then(response => {
            if(response.code === 200) {
                let data =  this.transform(response);
                
                if(data.success) {
                    let payload = this.saveSession(data);
                    if(payload) {
                        this.props.updateAccount(payload);
                    }
                } 
                setTimeout(function (){
                    window.location.hash = "/";
                    window.location.reload();
                },100)
            } else {
                setTimeout(function (){
                    window.location.hash = "/";
                    window.location.reload();
                },3000)
            }
        });
    }

    transform(response) {
        const data = response.payload.data;
        
        return {
            success: true,
            code: response.code,
            message: response.message,
            payload: {
            account: {
                id: data.employeeId,
                loginName: data.loginName,
                realName: data.realName,
                orgName : data.orgXzName,
                orgId : data.orgXzId,
                schoolName: data.schoolName,
                termName: data.termName,
                yearName: data.yearName,
                termId: data.termId,
                yearId: data.yearId,
                dudao: data.dudao,
                userType: data.userType,
                systemName: data.systemName
            },
            rules: data.roleModuleList.map((rule) => {
                if((rule.url || "").indexOf('/datav/index/') !== -1) {
                    var link = rule.url.split('/datav/index/')[1];
                    if(link) {
                        rule.url = "/datav/index/"+escape(link);
                    }
                }
                return {
                    id: rule.id,
                    name: rule.name,
                    pid: rule.pid,
                    url: rule.url,
                    depth: rule.level,
                    icon: rule.icon,
                    label: rule.label,
                    orderNum: rule.orderNum
                }
            }),
            roleIds: data.roleIds,
            }
        };
    }
    
    // saveSession(data) {
    //     var result = utils.tree(data.payload.rules);
    //     window.sessionStorage.setItem('session', JSON.stringify({
    //         account: data.payload.account,
    //         rules: result[0].children
    //     }));
        
    //     return data.payload;
    // }

    saveSession (data) {
        var result = utils.tree(data.payload.rules);
        const operation = {};
        window.sessionStorage.setItem('session', JSON.stringify({
            account: data.payload.account,
            rules: (result && result.length > 0) ? result[0].children : [],
            roleIds: data.payload.roleIds,
            operation: operation
        }));
        
        return data.payload;
    }

    render() {
        return (
            <div>
                登陆中。。。        
            </div>
        );
    }
}